import { ref } from "vue";
import { useRest } from "./useRest";

export function useProsecutor() {
  const rest = useRest();

  const prosecutorUserTypes = ref({});

  const cleanData = () => {
    let prosecutorUserTypesNames = [];
    prosecutorUserTypes.value.map((userType) => {
      prosecutorUserTypesNames.push(userType.Nombre);
    });
    prosecutorUserTypes.value = prosecutorUserTypesNames;
  };

  const initProsecutor = async () => {
    let url =
      process.env.VUE_APP_BACKEND_ENVIRONMENT + "/parametros/tipo-usuario?TipoUsuarioPadre=Fiscal";
    const result = await rest.get({ url });
    prosecutorUserTypes.value = result.data.data;
    cleanData();
  };

  return {
    prosecutorUserTypes,
    initProsecutor,
    cleanData,
  };
}
